/*! titan-imei.js (IMEI with manual entry + validation)
 * - Works with a text input (name="titan_imei") and optional datalist suggestions
 * - Accepts only IMEIs 14–18 digits that start with 863/864/868/869/3571
 * - Keeps hidden properties[IMEI] in sync
 * - Injects properties into the submitting form (covers AJAX add-to-cart & “Buy it now”)
 * - Validates early on button click (capture) to stop custom /cart/add.js handlers if invalid
 */
(function(){
  var TITAN_ATTR = '[data-titan-imei]';
  var ADD_TO_CART_FORM_SELECTOR = 'form[action*="/cart/add"], product-form form, form[action="/cart/add"]';
  var ALLOWED_PREFIXES_DEFAULT = ['863','864','869','8682','3571'];

  function forEachNode(list, cb){ Array.prototype.forEach.call(list, cb); }
  function digitsOnly(s){ return (s || '').replace(/\D+/g, ''); }
  function allowedPrefixes(container){
    var ds = container && container.getAttribute('data-allowed-prefixes');
    if(!ds) return ALLOWED_PREFIXES_DEFAULT.slice();
    return ds.split(',').map(function(x){ return x.trim(); }).filter(Boolean);
  }
  function isValidTitanIMEI(raw, container){
    var v = digitsOnly(raw);
    if (v.length !== 15) return false;
    var allowed = allowedPrefixes(container);
    // 3571 and 8682 are 4-digit prefixes; others are 3-digit
    if (v.indexOf('3571') === 0) return true;
    if (v.indexOf('8682') === 0) return true;
    for (var i=0; i<allowed.length; i++){
      var p = allowed[i];
      if (p === '3571') continue;
      if (v.indexOf(p) === 0) return true;
    }
    return false;
  }

  function getContainerForForm(form){
    // Prefer container inside the form; fallback: first one on the page
    return (form && form.querySelector(TITAN_ATTR)) || document.querySelector(TITAN_ATTR);
  }

  function currentIMEI(container){
    if(!container) return '';
    var input = container.querySelector('input[name="titan_imei"]');
    var select = container.querySelector('select[name="titan_imei_select"]'); // legacy fallback
    var v = input ? input.value : (select ? select.value : '');
    return (v || '').trim();
  }

  function setHiddenIMEI(container, val){
    var hidden = container && container.querySelector('input[name="properties[IMEI]"]');
    if(hidden){ hidden.value = digitsOnly(val || ''); }
  }

  function showError(container, show, msg){
    var el = container && container.querySelector('[data-imei-error]');
    if(!el) return;
    if (msg) el.textContent = msg;
    el.style.display = show ? '' : 'none';
  }

  function syncHidden(container){
    if(!container) return;
    setHiddenIMEI(container, currentIMEI(container));
  }

  function prefillIfSingle(container){
    var input = container && container.querySelector('input[name="titan_imei"]');
    var listId = input && input.getAttribute('list');
    if (!input || !listId) return;
    var dl = document.getElementById(listId);
    if (!dl) return;
    var opts = Array.from(dl.querySelectorAll('option')).map(function(o){ return (o.getAttribute('value') || '').trim(); }).filter(Boolean);
    if (opts.length === 1 && !input.value) {
      input.value = opts[0];
      syncHidden(container);
      validateLive(container);
    }
  }

  function validateLive(container){
    var input = container && container.querySelector('input[name="titan_imei"]');
    if(!input) return;
    var v = input.value;
    if (!v) { showError(container, false); return; }
    if (!isValidTitanIMEI(v, container)) {
      showError(container, true, 'Not a valid Titan device.');
      input.setCustomValidity('Not a valid Titan device.');
    } else {
      showError(container, false);
      input.setCustomValidity('');
    }
  }

  function ensureProp(form, name, value){
    if(!form) return;
    var input = form.querySelector('input[name="'+name.replace(/"/g,'&quot;')+'"]');
    if(!input){
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = value;
  }

  function handleSubmit(e){
    var form = e.target;
    if(!form || !form.matches(ADD_TO_CART_FORM_SELECTOR)) return;

    var container = getContainerForForm(form);
    if(!container) return;

    var imeiRaw = currentIMEI(container);
    var imeiDigits = digitsOnly(imeiRaw);

    if(!imeiDigits){
      if (typeof e.preventDefault === 'function') e.preventDefault();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      alert('Please enter your device IMEI before continuing.');
      return;
    }
    if(!isValidTitanIMEI(imeiRaw, container)){
      if (typeof e.preventDefault === 'function') e.preventDefault();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      alert('Not a valid Titan device.');
      return;
    }

    // Sync hidden + inject into the submitting form
    setHiddenIMEI(container, imeiDigits);
    ensureProp(form, 'properties[IMEI]', imeiDigits);
    ['properties[Customer ID]', 'properties[Renewal SKU]'].forEach(function(name){
      var src = container.querySelector('input[name="'+name+'"]');
      if(src && src.value){ ensureProp(form, name, src.value); }
    });
  }

  function attachToForms(root){
    var scope = root || document;
    var forms = scope.querySelectorAll(ADD_TO_CART_FORM_SELECTOR);
    forEachNode(forms, function(f){
      if(!f.__titanImeiBound){
        f.addEventListener('submit', handleSubmit, {capture:true});
        f.__titanImeiBound = true;
      }
    });
  }

  function bindContainers(root){
    var scope = root || document;
    var containers = scope.querySelectorAll(TITAN_ATTR);
    forEachNode(containers, function(ctn){
      // Bind input change for live validation + hidden sync
      var input = ctn.querySelector('input[name="titan_imei"]');
      if (input && !input.__titanImeiBound){
        input.addEventListener('input', function(){
          syncHidden(ctn);
          validateLive(ctn);
        });
        input.addEventListener('change', function(){
          syncHidden(ctn);
          validateLive(ctn);
        });
        input.__titanImeiBound = true;
      }
      // Legacy select support (if present anywhere)
      var select = ctn.querySelector('select[name="titan_imei_select"]');
      if (select && !select.__titanImeiBound){
        select.addEventListener('change', function(){
          syncHidden(ctn);
          validateLive(ctn);
        });
        select.__titanImeiBound = true;
      }
      prefillIfSingle(ctn);
      syncHidden(ctn);
      validateLive(ctn);
    });
  }

  // Initial bind
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){
      attachToForms(document);
      bindContainers(document);
    });
  } else {
    attachToForms(document);
    bindContainers(document);
  }

  // MutationObserver for quick-add modals / dynamic sections
  var mo = new MutationObserver(function(muts){
    muts.forEach(function(m){
      forEachNode(m.addedNodes, function(node){
        if(!(node instanceof Element)) return;
        if(node.matches && (node.matches(ADD_TO_CART_FORM_SELECTOR) || node.matches(TITAN_ATTR))){
          attachToForms(node);
          bindContainers(node);
        } else {
          attachToForms(node);
          bindContainers(node);
        }
      });
    });
  });
  mo.observe(document.documentElement, {childList:true, subtree:true});

  // Capture-phase click guard to stop custom add-to-cart handlers if invalid
  document.addEventListener('click', function(ev){
    var btn = ev.target && ev.target.closest && ev.target.closest('button, input[type="submit"]');
    if(!btn) return;
    var form = btn.form || (btn.closest && btn.closest('form'));
    if(!form || !form.matches(ADD_TO_CART_FORM_SELECTOR)) return;

    var container = getContainerForForm(form);
    if(!container) return;

    var imeiRaw = currentIMEI(container);
    var imeiDigits = digitsOnly(imeiRaw);
    if(!imeiDigits){
      ev.preventDefault(); ev.stopImmediatePropagation();
      alert('Please enter your device IMEI before continuing.');
      return;
    }
    if(!isValidTitanIMEI(imeiRaw, container)){
      ev.preventDefault(); ev.stopImmediatePropagation();
      alert('Not a valid Titan device.');
      return;
    }

    // Pre-inject so any immediate serialization picks it up
    ensureProp(form, 'properties[IMEI]', imeiDigits);
    ['properties[Customer ID]', 'properties[Renewal SKU]'].forEach(function(name){
      var src = container.querySelector('input[name="'+name+'"]');
      if(src && src.value){ ensureProp(form, name, src.value); }
    });
  }, true);
})();
